import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/metta-world'
  },
  {
    path: '/metta-world',
    name: 'MettaWorld',
    component: () => import('@/views/metta-world.vue'),
    meta: { title: 'Metta World' }
  },
  {
    path: '/badain-jaran',
    name: 'BadainJaran',
    component: () => import('@/views/badain-jaran.vue'),
    meta: { title: '巴丹吉林 — Metta' }
  },
  {
    path: '/n30-loki',
    name: 'N30Loki',
    component: () => import('@/views/n35-loki.vue'),
    meta: { title: 'N30° — Metta' },
  },
  {
    path: '/n30-three-doors',
    name: 'N30ThreeDoors',
    component: () => import('@/views/n35-three-doors.vue'),
    meta: { title: 'N30° — Metta' },
  },
  {
    path: '/n30-cross',
    name: 'N30Cross',
    component: () => import('@/views/n35-cross.vue'),
    meta: { title: 'N30° — Metta' },
  },
  // {
  //   path: '/n30-loki',
  //   component: () => import('@/views/n35.vue'),
  //   children: [
  //     {
  //       path: '',
  //       name: 'N30Loki',
  //       component: () => import('@/views/n35-loki.vue'),
  //       meta: { title: 'N30° — Metta' },
  //     },
  //     {
  //       path: 'three-doors',
  //       name: 'N30ThreeDoors',
  //       component: () => import('@/views/n35-three-doors.vue'),
  //       meta: { title: 'N30° — Metta' },
  //     },
  //     {
  //       path: 'cross',
  //       name: 'N30Cross',
  //       component: () => import('@/views/n35-cross.vue'),
  //       meta: { title: 'N30° — Metta' },
  //     }
  //   ]
  // },
  {
    path: '/ultra',
    name: 'Ultra',
    component: () => import('@/views/ultra-main.vue'),
    meta: { title: 'Ultra — Metta Performance' }
  },
  {
    path: '/ultra-t1',
    name: 'UltraT1',
    component: () => import('@/views/ultra-t1.vue'),
    meta: { title: 'Ultra-t1 — Metta Performance' }
  },
  {
    path: '/ultra-utv',
    name: 'UltraUTV',
    component: () => import('@/views/ultra-utv.vue'),
    meta: { title: 'Ultra-Utv — Metta Performance' }
  },
  // {
  //   path: '/ultra',
  //   component: () => import('@/views/ultra.vue'),
  //   children: [
  //     {
  //       path: '',
  //       name: 'Ultra',
  //       component: () => import('@/views/ultra-main.vue'),
  //       meta: { title: 'Ultra — Metta Performance' }
  //     },
  //     {
  //       path: 't1',
  //       name: 'UltraT1',
  //       component: () => import('@/views/ultra-t1.vue'),
  //       meta: { title: 'Ultra-t1 — Metta Performance' }
  //     },
  //   ]
  // },
  {

    path: '/classic-ebike',

    name: 'ClassicEbike',

    component: () => import('@/views/classic-ebike.vue'),

    meta: { title: 'METTA Classic E-Bike' }

  },

  {
    path: '/community2',
    name: 'Community2',
    component: () => import('@/views/community2.vue'),
    meta: { title: 'METTA · 社区',hideFooter: true }
  },
  {
    path: '/metta-community',
    name: 'MettaCommunity',
    component: () => import('@/views/metta-community.vue'),
    meta: { title: 'METTA · 社区' }
  },
  {
    path: '/metta-channel',
    name: 'MettaChannel',
    component: () => import('@/views/metta-channel.vue'),
    meta: { title: 'METTA · 渠道网络' }
  },
  {
    path: '/metta-store',
    name: 'MettaStore',
    component: () => import('@/views/metta-store.vue'),
    meta: { title: 'METTA · 商城' }
  },
  {
    path: '/garage',
    name: 'Garage',
    component: () => import('@/views/garage.vue'),
    meta: { title: '载具库 — Metta' }
  },
  {
    path: '/events',
    name: 'Events',
    component: () => import('@/views/events.vue'),
    meta: { title: '赛事 — Metta' }
  },
  {
    path: '/eos-missions',
    name: 'EOSMissions',
    component: () => import('@/views/eos-missions.vue'),
    meta: { title: 'METTA — EOSMissions', hideNav: true }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/about.vue'),
    meta: { title: '关于 — Metta', }
  },
]

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'nav-active',
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有 savedPosition（比如用户点击了浏览器的前进/后退），就恢复位置
    if (savedPosition) {
      return savedPosition;
    }
    
    // 如果是新进入的页面，滚动到顶部
    return { x: 0, y: 0 };
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title // 赋值给浏览器标题
  }
  next()
})

export default router